module.exports = __webpack_public_path__ + "static/media/phone-svg.9c746531.svg";